module.exports = __webpack_public_path__ + "img/round-save-24px.de7cee30.svg";